import React from 'react';
import { FormattedMessage } from 'react-intl';

type ErrorLayoutProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  slotContent?: any;
};

const ErrorLayout: React.FC<ErrorLayoutProps> = ({
  title,
  children,
  slotContent = {},
}) => {
  return (
    <>
      <article id="page-document" className="page">
        <section className="page__section page__section--compact">
          <div className="page__section-intro">
            <h1 className="page__section-title">
              {title ?? (
                <FormattedMessage
                  id="error.genericHeroTitle"
                  defaultMessage="Something went wrong"
                />
              )}
            </h1>
          </div>
          <div className="page__section-content">{children}</div>
        </section>
      </article>
    </>
  );
};

export default ErrorLayout;
